import { Container, Row, Col, Carousel, Card, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Form, Button, Alert } from 'react-bootstrap';
import portugal from '../../img/11.png'
import video from '../../img/video.mp4'
const Quemsomos=()=>{
    return(
        <section style={{ marginBottom: '11.875rem' }}>
        <Container>
          <Row>

            <Col lg={6}>
              <h2 className="text-center" style={{ position: 'relative', fontSize: '46px', display: 'inline-block' }}>
                <b>Quem somos</b>
                <div style={{
                  position: 'absolute',
                  bottom: 0,
                  left: '0',
                  width: '50%', // Ajuste a largura do sublinhado para cobrir a parte desejada
                  height: '2px',
                  backgroundColor: '#ff5722' // Cor do sublinhado
                }} />
              </h2>
              <p>
              Somos a N.Wayami, empresa 100% angolana, oferecemos soluções estratégicas 
que simplificam, otimizam e agregam valor aos negócios. Atuamos nas áreas de 
manutenção predial, tecnologia de informação e consultoria, sempre com foco em 
eficiência, inovação e resultados. </p>



              <Link to="/NossoTeam">
                <Button style={{ backgroundColor: '#FF5722', borderColor: '#FF5722', width: '109px', padding: '10px' }}>
                  Saiba mais
                </Button>
              </Link>
            </Col>



            {/* Referências (lado esquerdo) */}
            <Col lg={6} style={{ height: 'auto' }}>
  <div className="card" style={{ flex: 1, margin: '10px', border: 'none' }}>
    <div style={{ position: 'relative' }}>
      <video
        style={{ width: '100%', height: 'auto', borderRadius: '8px' }}
        controls
        poster={portugal}
      >
        <source src={video} type="video/mp4" />
        Seu navegador não suporta o elemento de vídeo.
      </video>
    </div>
  </div>
</Col>

          </Row>


        </Container>
        <div id='servicos'></div></section>
    )
}

export default Quemsomos;